export const BASE_CITY = 'BASE_CITY'
export const BASE_CITY_PREPOSITIONAL = 'BASE_CITY_PREPOSITIONAL'
export const BASE_CITY_ID = 'BASE_CITY_ID'
export const BASE_CITY_SELECTED_BY_USER = 'BASE_CITY_SELECTED_BY_USER'
export const BASE_CITY_PHONE = 'BASE_CITY_PHONE'
export const CLEAR = 'CLEAR'



// WEBPACK FOOTER //
// ./src/constants/BaseCity.js